module.exports = __webpack_public_path__ + "img/vip.8442d7bc.png";